// extracted by mini-css-extract-plugin
export default {"ico":"IconTextResponsive_ico__twOio","textDiv":"IconTextResponsive_textDiv__KwvZi"};